import React, { useEffect, useRef } from "react";
import { IMAGES } from "../../data/mock";

const SLIDES = [
  { img: "heroLift", label: "Programmed strength", tag: "Body" },
  { img: "praySunrise", label: "Daily devotional rhythm", tag: "Heart" },
  { img: "darkGym", label: "Discipline of the road", tag: "Mind" },
  { img: "fatherSon", label: "Lead the home", tag: "Home" },
  { img: "forgeMan", label: "Forged in private", tag: "Forge" },
  { img: "coachAlt", label: "Iron sharpens iron", tag: "Brotherhood" }
];

export default function GalleryStrip() {
  const track = useRef(null);
  useEffect(() => {
    const el = track.current; if (!el) return;
    const on = () => {
      const r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      const p = (window.innerHeight - r.top) / (window.innerHeight + r.height);
      const x = (p - 0.5) * 320; // horizontal parallax range
      el.style.transform = `translate3d(${-x}px, 0, 0)`;
    };
    window.addEventListener("scroll", on); on();
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <section className="relative py-20 md:py-28 border-b hairline overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mb-10 md:mb-14 flex items-end justify-between gap-6">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] mb-4">The Field</div>
          <h3 className="font-display text-[42px] md:text-[72px] leading-[0.98] tracking-[-0.03em]">Life in the <span className="italic-serif text-[var(--ember-3)]">brotherhood</span>.</h3>
        </div>
        <div className="hidden md:block font-mono text-[11px] uppercase tracking-[0.22em] text-[var(--text-muted)] max-w-[280px]">A glimpse at what training the whole man looks like on a Tuesday morning.</div>
      </div>

      <div className="relative w-full overflow-hidden">
        <div ref={track} className="flex gap-6 md:gap-10 pl-6 md:pl-10 will-change-transform transition-transform duration-100">
          {SLIDES.map((s, i) => (
            <figure key={i} className="group relative shrink-0 w-[75vw] md:w-[36vw] lg:w-[28vw] aspect-[3/4] overflow-hidden border hairline-2">
              <img src={IMAGES[s.img]} alt={s.label} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.08] group-hover:filter-none" style={{filter:"grayscale(0.35) brightness(0.85)"}} />
              <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 45%, rgba(10,9,8,0.85) 100%)" }}></div>
              <figcaption className="absolute left-5 bottom-5 right-5">
                <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--ember-3)]">{s.tag}</div>
                <div className="font-display text-[26px] md:text-[30px] leading-[1] tracking-[-0.02em] mt-2">{s.label}</div>
              </figcaption>
              <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500" style={{ boxShadow: "inset 0 0 120px rgba(201,114,42,0.25)" }}></div>
            </figure>
          ))}
        </div>
        {/* Edge fades */}
        <div className="absolute inset-y-0 left-0 w-24 pointer-events-none" style={{ background: "linear-gradient(90deg, var(--bg), transparent)" }}></div>
        <div className="absolute inset-y-0 right-0 w-24 pointer-events-none" style={{ background: "linear-gradient(270deg, var(--bg), transparent)" }}></div>
      </div>
    </section>
  );
}
